const config = {
    basename: '/',
    defaultPath: '/',
    fontFamily: `'Montserrat', sans-serif`,
    borderRadius: 12,
    apiURL: 'https://api.etakit.in',
    cluster: 'https://wider-falling-firefly.solana-mainnet.discover.quiknode.pro/9bcba0c1c16d1435fe07126ee2790a679cdd78aa/'
};

export default config;